module.exports = __webpack_public_path__ + "static/media/citroen_logo.334800d8.png";